import React, { useState, useEffect, Fragment } from 'react';
import styles from './index.module.scss';
import { CopyOutlined } from '@ant-design/icons';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  message,
  Upload,
  TimePicker,
  Table,
  Alert,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
import { getLocalUrl } from '../../../functions';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Layout from '../../../layouts/User';
import OverwriteMomentBE from '../../../services/picker/OverwriteMomentBE';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from 'moment';
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { MuiPickersOverrides } from '@material-ui/pickers/typings/overrides';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { convertPrice } from '../../../utils/display';
type overridesNameToClassKey = {
  [P in keyof MuiPickersOverrides]: keyof MuiPickersOverrides[P];
};
declare module '@material-ui/core/styles/overrides' {
  export interface ComponentNameToClassKey extends overridesNameToClassKey {}
}

const timeFormat = 'HH:mm';

const breadcrumbs = [
  {
    text: 'หน้าแรก',
    path: '/',
  },
  {
    text: 'ตะกร้าสินค้า',
    path: '/cart',
  },
  {
    text: 'แจ้งชำระเงิน',
    path: '/confirm-payment',
  },
];

export type Props = {};
type LayoutType = Parameters<typeof Form>[0]['layout'];

const Register: React.FC<Props> = (props) => {
  const [selectedDate, handleDateChange] = useState<any>(
    moment().add(0, 'year')
  );
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  let [order, setOrder] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);

  const [showAnnounce, setShowAnnounce] = useState<boolean>(false);
  useEffect(() => {
    const now = new Date();
    if (
      now.getFullYear() === 2023 &&
      now.getMonth() === 3 &&
      now.getDate() <= 17
    ) {
      setShowAnnounce(true);
    }
  }, []);

  const columns = [
    {
      title: 'Payment No.',
      dataIndex: 'paymentNo',
      key: 'paymentNo',
    },
    {
      title: 'ยอดชำระ',
      render: (record: any) => (
        <span>
          {record.newAmountTranfer === '0'
            ? '฿' + record.formatTotalPrice
            : '฿' + record.newAmountTranfer + ' (เพิ่มเติม)'}
        </span>
      ),
      key: 'formatTotalPrice',
    },
    {
      title: 'วันที่ชำระ',
      dataIndex: 'formatTransferDate',
      key: 'formatTransferDate',
    },
    {
      title: 'เวลาที่ชำระ',
      dataIndex: 'formatTransferTime',
      key: 'formatTransferTime',
    },
    {
      title: 'หลักฐานการชำระเงิน',
      dataIndex: 'slipUrl',
      key: 'slipUrl',
      render: (value: any) => (
        <a
          onClick={() => {
            onShowProofClick(value);
          }}
        >
          ดูหลักฐานการชำระเงิน
        </a>
      ),
    },
    {
      title: 'เวลาที่อัพโหลดเอกสาร',
      dataIndex: 'formatCreatedAt',
      key: 'formatCreatedAt',
    },
  ];

  const [form] = Form.useForm();
  const [formLayout, setFormLayout] = useState<LayoutType>('vertical');
  const [file, setFile] = useState<any>({
    url: null,
    raw: null,
  });

  const [confirmPayments, setConfirmPayments] = useState<any>([]);

  const onShowProofClick = (url: any) => {
    window.open(url, '_blank');
  };

  const getOrder = async () => {
    const { data } = await axios.get(
      `/orders/show-order/${searchParams.get('id')}`
    );
    setOrder(data);
  };

  const nextPage = () => {
    setLoading(false);
    navigate(`/cart/confirm-cart?id=${searchParams.get('id')}`);
  };

  const confirmButton = async (values: any) => {
    const { datePayment, timePayment } = values;
    const orderId = searchParams.get('id');

    if (!file.raw) {
      message.warning('กรุณาอัพโหลดสลิปการโอน!');
      return;
    }

    setLoading(true);
    try {
      const body = {
        type: 'upload_slip',
        status: 'check_payment',
        confirmPayment: {
          order: orderId,
          totalPrice: order.totalPrice,
          newAmountTranfer: order.newAmountTranfer,
          transferDate: datePayment,
          transferTime: timePayment,
        },
      };

      const {
        data: { confirmPayment },
      } = await axios.patch(`/orders/${orderId}`, body);

      const bodyOrderShop = {
        status: 'check_payment',
      };

      for (let i = 0; i < order.shops.length; i++) {
        await axios.patch(
          `/ordershops/${order.shops[i].orderShop._id}`,
          bodyOrderShop
        );
      }

      // upload slip

      if (file.raw) {
        const fmData = new FormData();
        const config = {
          headers: { 'content-type': 'multipart/form-data' },
        };

        fmData.append('file', file.raw);

        await axios.post(
          `/confirm-payments/upload-document?confirmPaymentId=${confirmPayment._id}&orderId=${orderId}`,
          fmData,
          config
        );
      }

      axios.post(`/line/send-messages`, {
        type: 'order_created',
        orderId,
      });

      /** Redeem Promotion */
      // const shop = order.shops[0];
      // if (shop && shop.orderShop && shop.orderShop.promotion) {
      //   await axios.patch(
      //     `/promotions/redeem`,
      //     { code: shop.orderShop.promotion.code }
      //   );
      // }
      /** End Redeem Promotion */

      setTimeout(nextPage, 1000);
    } catch (err) {
      message.error('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง!');

      setLoading(false);
    }
  };

  const onFormLayoutChange = ({ layout }: { layout: LayoutType }) => {
    setFormLayout(layout);
  };

  const onPreview = (file: any) => {
    const url = getLocalUrl(file?.originFileObj);
    window.open(url, '_blank');
  };

  const onUploadChange = (e: any) => {
    if (e.file.status === 'done') {
      // console.log("file change...", e);
      const { originFileObj } = e.file;

      const url = getLocalUrl(originFileObj);
      setFile({ url, raw: originFileObj });
    }
  };

  const getConfirmPayments = async () => {
    const orderId = searchParams.get('id');
    const { data } = await axios.get(`/confirm-payments/${orderId}`);
    setConfirmPayments(data.data);
  };

  const getApis = () => {
    getConfirmPayments();
  };

  const onDatePickerChange = (value: any) => {
    handleDateChange(value);
    form.setFieldsValue({
      ...form,
      datePayment: value,
    });
  };

  useEffect(() => {
    form.setFieldsValue({
      ...form,
      totalPrice: convertPrice(order.totalPrice),
      newAmountTranfer: convertPrice(order.newAmountTranfer),
      datePayment: moment(),
    });
  }, [order]);

  useEffect(() => {
    getOrder();
    getApis();
  }, []);

  const theme = createTheme({
    overrides: {
      MuiButton: {
        textPrimary: {
          color: '#2d6fa5',
        },
      },
      MuiPickersDay: {
        day: {
          color: 'black',
        },
        daySelected: {
          backgroundColor: '#2d6fa5',
          '&:hover': {
            backgroundColor: '#2d6fa5',
          },
        },
        dayDisabled: {
          color: '#ccc',
        },
        current: {
          color: '#2d6fa5',
        },
      },
      MuiPickersToolbar: {
        toolbar: {
          backgroundColor: '#2d6fa5',
        },
      },
    },
  });

  return (
    <>
      <Layout breadcrumbItems={breadcrumbs} breadcrumbMarginBottom={50}>
        <div className={styles.Wapper}>
          <Row>
            <Col xs={24} sm={24} md={8} lg={10}>
              <div className={styles.boxWrapper}>
                <div className={styles.detailWrapper}>
                  <div className={styles.qrCodeText}>
                    <img
                      src={`/images/SCB.png`}
                      alt='avatar'
                      style={{ maxWidth: '100%', marginTop: 5 }}
                    />
                  </div>
                  <div className={styles.textWrapper}>
                    <div className={styles.titleHelpText}>
                      กรุณาชำระเงิน{' '}
                      {order.newAmountTranfer === undefined
                        ? ''
                        : '(เพิ่มเติม)'}
                    </div>

                    <div
                      className={styles.priceText}
                      style={{ color: '#045de9', fontSize: '24px' }}
                    >
                      {`${convertPrice(
                        order.newAmountTranfer === undefined
                          ? order.totalPrice
                          : order.newAmountTranfer
                      )} บาท`}
                    </div>

                    <div className={styles.bankText}>
                      ชื่อบัญชี : เอสซีจี ดิสทริบิวชั่น จำกัด(พร้อมดี)
                    </div>

                    <div className={styles.bankText}>
                      เลขบัญชี : 468-1094557{' '}
                      <CopyToClipboard
                        text='4681094557'
                        onCopy={() => message.success('คัดลอกเรียบร้อย')}
                      >
                        <button>
                          คัดลอก
                          <CopyOutlined />
                        </button>
                      </CopyToClipboard>
                    </div>
                    {showAnnounce ? (
                      <div style={{ padding: '8px 0' }}>
                        <Alert
                          message='เนื่องจากร้านค้าบางร้านจะปิดทำการในวันหยุดนักขัตฤกษ์เดือนเมษายน
                      ทำให้การสั่งซื้อและจัดส่งสินค้าอาจเกิดความล่าช้า'
                          banner
                        />
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={24} sm={24} md={8} lg={10}>
              <div className={styles.formWrapper}>
                <div className={styles.formContainer}>
                  <h1 className={styles.header}>
                    แจ้งชำระเงิน{' '}
                    {order.newAmountTranfer === undefined ? '' : '(เพิ่มเติม)'}
                  </h1>
                  <Form
                    onFinish={confirmButton}
                    layout='vertical'
                    form={form}
                    // initialValues={{ layout: formLayout }}
                    onValuesChange={onFormLayoutChange}
                  >
                    {order.newAmountTranfer === undefined ? (
                      <Form.Item label='ยอดโอน (บาท)' name={`totalPrice`}>
                        <Input
                          value={convertPrice(order.totalPrice)}
                          readOnly
                        />
                      </Form.Item>
                    ) : (
                      <Form.Item label='ยอดโอน (บาท)' name={`newAmountTranfer`}>
                        <Input
                          value={`${convertPrice(order.newAmountTranfer)}`}
                          readOnly
                        />
                      </Form.Item>
                    )}
                    <Form.Item
                      label='วันที่โอน'
                      name={`datePayment`}
                      rules={[
                        {
                          required: true,
                          message: 'โปรดป้อนข้อมูล!',
                        },
                      ]}
                    >
                      <ThemeProvider theme={theme}>
                        <MuiPickersUtilsProvider
                          utils={OverwriteMomentBE}
                          locale='th'
                        >
                          <Fragment>
                            <DatePicker
                              size='small'
                              format='DD/MM/yyyy'
                              views={['year', 'month', 'date']}
                              value={selectedDate}
                              onChange={onDatePickerChange}
                              className={styles.datePicker}
                            />
                          </Fragment>
                        </MuiPickersUtilsProvider>
                      </ThemeProvider>
                    </Form.Item>
                    <Form.Item
                      label='เวลาที่โอน'
                      name={`timePayment`}
                      rules={[
                        {
                          required: true,
                          message: 'โปรดป้อนข้อมูล!',
                        },
                      ]}
                    >
                      <TimePicker
                        name='timePayment'
                        placeholder='เลือกเวลา'
                        format={timeFormat}
                        style={{ width: '100%' }}
                      />
                    </Form.Item>
                    <div className='label mb-3'>
                      <span className='required'>*</span>สลิปการโอน
                      <br />
                      <span>หากยอดชำระเป็น 0 บาท ให้อัพโหลดรูปใดแทนก็ได้</span>
                    </div>
                    <Upload
                      name='avatar'
                      showUploadList={false}
                      customRequest={({ onSuccess }: any) => {
                        onSuccess();
                      }}
                      onPreview={onPreview}
                      onChange={onUploadChange}
                    >
                      <Button style={{ width: '100%' }} icon={<PlusOutlined />}>
                        อัพโหลดสลิป
                      </Button>
                    </Upload>
                    {file?.url && (
                      <img
                        src={file?.url}
                        alt='avatar'
                        style={{ maxWidth: '100%', marginTop: 5 }}
                      />
                    )}
                    <Form.Item style={{ textAlign: 'right' }}>
                      <Button
                        htmlType='submit'
                        className={`${styles.confirmButton}`}
                        type='primary'
                        loading={loading}
                        style={{ width: `100%`, marginTop: 20 }}
                      >
                        แจ้งชำระเงิน
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
              </div>
            </Col>

            {confirmPayments.length > 0 && (
              <>
                <Col sm={24} md={24} lg={24}>
                  <hr />
                </Col>
                <Col sm={24} md={24} lg={24}>
                  <div className='mb-5 mt-5'>ประวัติการชำระเงิน</div>
                  <Table
                    columns={columns}
                    dataSource={confirmPayments}
                    rowKey='_id'
                  />
                </Col>
              </>
            )}
          </Row>
        </div>
      </Layout>
    </>
  );
};
export default Register;
